import React from 'react';
import { GoogleLogo, Stars } from './GoogleReviews';
import { googleRating } from '../data/stats';

// Alternate display of the Google rating: open, inline, no card.
export function GoogleRatingStrip() {
  const {
    score,
    value,
    count
  } = googleRating;
  return <div role="group" aria-label={`Google-Bewertungen: ${score} von 5 Sternen aus ${count} Rezensionen`} className="flex flex-col items-center gap-4 sm:flex-row sm:gap-6" style={{
    fontFamily: 'Roboto, Arial, sans-serif',
    letterSpacing: 0
  }} data-id="element-237" data-mp="22nwd1do8kh61">
      <div className="flex items-center gap-3" aria-hidden="true" data-id="element-238" data-mp="2qgczs1ix4xbo">
        <span className="text-[44px] font-medium leading-none text-[#202124]" data-id="element-239" data-mp="2lfxkv5iznhrl">{score}</span>
        <div className="text-left" data-id="element-240" data-mp="2gif9l8hi0qgf">
          <Stars value={value} data-id="element-241" data-mp="2gh49bin9i0u2" />
          <p className="mt-1 text-[13px] text-[#5f6368]" data-id="element-242" data-mp="1a1k0iang1kgb">{count} Rezensionen</p>
        </div>
      </div>
      <span className="hidden h-10 w-px bg-line sm:block" aria-hidden="true" data-id="element-243" data-mp="152gvurbdlg8v" />
      <div className="flex items-center gap-2.5" aria-hidden="true" data-id="element-244" data-mp="154l9w22znvmv">
        <GoogleLogo className="h-6 w-6" data-id="element-245" data-mp="1mo9rtudezhcv" />
        <span className="text-[15px] text-[#3c4043]" data-id="element-246" data-mp="1rm1lastpjbj6">
          Bewertet auf <span className="font-medium" data-id="element-247" data-mp="1rla1ef9h328q">Google</span>
        </span>
      </div>
    </div>;
}